/**
 * 社区部落路由
 */
const routerCommunity = [
  {
    path: '/community',
    name: 'Community',
    meta: {
      title: '数智社区',
      needLogin: false,
      transitionName: 'router',
      isTopMenu: true,
      isImgTitle: false,
      activeImgTitle: 'https://zzsk-video-upload.oss-cn-beijing.aliyuncs.com/static/images/router/icon_sq_alive.jpg',
      imgTitle: 'https://zzsk-video-upload.oss-cn-beijing.aliyuncs.com/static/images/router/icon_sq.jpg',
    },
    component: () => import('@/pages/module-community/index.vue'),
    redirect: '/community-knowledge-city',
  },
  {
    path: 'community-knowledge-city',
    name: 'CommunityKnowledgeCity',
    meta: {
      title: '知识城邦',
      needLogin: false,
      transitionName: 'router',
    },
    component: () => import('@/pages/module-community/knowledge-city-state/index.vue'),
  },
  {
    path: 'community-knowledge-detail',
    name: 'CommunityKnowledgeDetail',
    meta: {
      title: '知识城邦-文章详情',
      needLogin: false,
      transitionName: 'router',
    },
    component: () => import('@/pages/module-community/knowledge-city-state/articleDetails.vue'),
  },
  {
    path: 'community-knowledge-write-Article',
    name: 'CommunityKnowledgeWriteArticle',
    meta: {
      title: '知识城邦-写文章',
      needLogin: true,
      transitionName: 'router',
    },
    component: () => import('@/pages/module-community/knowledge-city-state/writeArticle.vue'),
  },
  {
    path: 'community-question-assistance',
    name: 'CommunityQuestionAssistance',
    meta: {
      title: '互助问答',
      needLogin: false,
      transitionName: 'router',
    },
    component: () => import('@/pages/module-community/question-assistance/index.vue'),
  },
  {
    path: 'community-my-question',
    name: 'CommunityMyQuestion',
    meta: {
      title: '互助问答-我的问题',
      needLogin: true,
      transitionName: 'router',
    },
    component: () => import('@/pages/module-community/question-assistance/questionList.vue'),
  },
  {
    path: 'community-question-detail',
    name: 'CommunityQuestionDetail',
    meta: {
      title: '互助问答-详情',
      needLogin: false,
      transitionName: 'router',
    },
    component: () => import('@/pages/module-community/question-assistance/questionDetail.vue'),
  },
  {
    path: 'community-view-point-details',
    name: 'CommunityViewpointDetails',
    meta: {
      title: '观点对对碰',
      needLogin: false,
      transitionName: 'router',
    },
    component: () => import('@/pages/module-community/CommunityViewpoint.vue'),
  },
];

export default routerCommunity;
